import styled from 'styled-components';

import DefaultAvatar from 'components/Avatar';

export const Avatar = styled(DefaultAvatar)``;
